import { InsurancePlanType, InsuranceReceiverType, InsuranceTypesType, PostOfficeType } from "../types";
import { Dispatch, SetStateAction } from "react";

export type PriorActivityDetailsType = {
  cptCode: string;
  insAmount: number;
  denialCode: string;
  remitNetAmount: number;
  remitPatShare: number;
  remitPayAmt: number;
  remitQty: number;
  comments: string;
};

export type PriorPatientDetailsType = {
  emiratesID: string;
  memberID: string;
  payerID: string;
  fullName: string;
  mobileNo: string;
  patientID: string;
  authorizationId: string;
};

export type PriorPatientDetailsType2 = {
  patientId: "AF00004";
  priorAuthId: 134;
  emiratesId: "784-2001-5466797-8";
  memberId: 5645657;
  uniqueAuthId: "PRI4ABDCEA";
};

export type PriorApprovalDownloadType = {
  patientDetails: PriorPatientDetailsType;
  activityDetails: PriorActivityDetailsType[];
};
// type PostOfficeObjectType = {
//   po_userName: string;
//   po_clinicLicense: string,
//   po_id: number,
//   po_name: string,
//   password2: string,
//   po_link: string,
//   up_link: string,
//   po_passWord: string,
//   po_clinicId: number
// }

export type PriorSearchParamsType = {
  clinicId: number;
  fromDate: string | null;
  pageNo: number;
  pageSize: number;
  status: number;
  toDate: string | null;
  insTypeId: number | null;
  insNameId: number | null;
  insGroupId: number | null;
  insPlanId: number | null;
  all: boolean;
  operation: "search" | "download";
  postOfficeId: number;
};

export type ApprovedSearchContextType = {
  priorApprovalSearchParams: Omit<PriorSearchParamsType, "clinicId">;
  setPriorApprovalSearchParams: Dispatch<
    SetStateAction<Omit<PriorSearchParamsType, "clinicId">>
  >;
  searchResult: SearchResponseType;
  setSearchResult: Dispatch<
    SetStateAction<Omit<SearchResponseType, "clinicId">>
  >;
  downloadLoading: boolean;
  setDowloadLoading: Dispatch<SetStateAction<boolean>>;
};



export type SearchResultType = {
  patientId: string;
  priorAuthId: number;
  emiratesId: string;
  memberId: number;
  uniqueAuthId: string;
};

export type SearchResponseType = {
  items: PriorApprovalDownloadType[];
  totalCount: number;
  responseMessage:string
};

export type PriorApprovalPateintSearchParams = {
  searchText: string;
  searchDate: string;
  pageSize: number;
  pageNo: number;
  refetch: boolean;
};

export type PriorApprovalPatientType = {
  fullName: string;
  payerId: string;
  encounterId: number;
  patientId: string;
  receiver: string;
  encFacilityId: string;
  clinicianCode: string;
  emiratesId: string;
  clinicianName: string;
  payer: string;
  cardNo: string;
  mobileNo: string;
  receiverId: string;
  createdById: number;
  patientMasterId: number;
  isApproved: number;
  postOfficeId: number;
};

export type PriorApprovalPatientResponseType = {
  items: PriorApprovalPatientType[];
  totalCount: number;
};

export type PriorApprovalSearchFormType = {
  all: boolean;
  fromDate: string;
  toDate: string;
  insuranceType: InsuranceTypesType | null;
  receiver: InsuranceReceiverType | null;
  payer: InsuranceReceiverType | null;
  insurancePlan:InsurancePlanType | null;
  postoffice: PostOfficeType | null;
};

export const initialSearchData: Omit<PriorSearchParamsType, "clinicId"> = {
  fromDate: "",
  toDate: "",
  pageNo: 0,
  pageSize: 25,
  insTypeId: 0,
  insNameId: 0,
  insGroupId: 0,
  insPlanId: 0,
  status: 1,
  all: true,
  operation: "search",
  postOfficeId: 1,
};

export const defaultFormData:PriorApprovalSearchFormType = {
  all:false,
  fromDate:"",
  toDate:"",
  insuranceType:null,
  receiver:null,
  payer:null,
  insurancePlan:null,
  postoffice:null,
}